var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_Amazon-Polly_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01a88d",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.008 31.002h5.002v-2h-5.002zm0 8.999h2v-4h-2zm-9.003-13h3v-1.999h-3zm-9.004 8h12.005v-2H14zm0-4h16.006v-2H14.001zm15.006 10h2v-7h-2zm15.006 0h2v-6h-2zm-3.001 2h2V33h-2zm-3.002-1h2.001v-8h-2zm-3-1h2v-7h-2zm17.854 10.222-3.453-6.754a13.2 13.2 0 0 0 1.829-6.739c0-7.382-6.006-13.389-13.387-13.389-2.188 0-4.354.536-6.263 1.55l.94 1.766a11.4 11.4 0 0 1 5.323-1.316c6.278 0 11.386 5.11 11.386 11.39 0 2.206-.627 4.33-1.813 6.142a1 1 0 0 0-.054 1.003l2.632 5.148L44.76 47.4a1 1 0 0 0-.967.04 11.44 11.44 0 0 1-5.94 1.671c-5.668 0-10.522-4.223-11.287-9.825l-1.984.272c.903 6.586 6.608 11.553 13.271 11.553 2.267 0 4.501-.579 6.495-1.68l6.893 3.448a1.228 1.228 0 0 0 1.417-.256 1.21 1.21 0 0 0 .206-1.4M14.001 27.002h7.003v-2H14zm11.004-8h5.372l-5.372-4.772zm-12.004 12H11v-19a1 1 0 0 1 1-.999L24.005 11c.24 0 .478.09.664.256l9.004 8a1 1 0 0 1 .336.746v3h-2v-2h-8.004a1 1 0 0 1-1-1V13L13 13.003zM13 41h11.004v2H12a1 1 0 0 1-1-1v-7h2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolly);
export default __webpack_public_path__ + "static/media/polly.c93e12fbb99342d17fb87eeb4bbadaea.svg";
export { ForwardRef as ReactComponent };